import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import scrollToTop from "../components/scrolltotop";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const location = useLocation();

  const menuThemeMap = {
    "/subjects/maths": "maths-menu",
    "/subjects/english": "eng-menu",
    "/subjects/verbal-reasoning": "vr-menu",
    "/subjects/non-verbal-reasoning": "nvr-menu",
  };

  const menuThemeClass = menuThemeMap[location.pathname] || "";

  const headerThemeMap = {
    "/subjects": "courses-header",
    "/subjects/maths": "maths-header",
    "/subjects/english": "eng-header",
    "/subjects/verbal-reasoning": "vr-header",
    "/subjects/non-verbal-reasoning": "nvr-header",
  };

  const headerThemeClass = headerThemeMap[location.pathname] || "";

  return (
    <>
      <div className="header-container ">
        <div
          className={`desktop-header ${
            scrolled ? "scrolled" : ""
          } ${headerThemeClass}`}
        >
          <Link to="/" className="header-logo" onClick={scrollToTop}>
            <img
              src="https://d1sq738v7irhr2.cloudfront.net/design-system/citos-logo.webp"
              alt="citos logo"
            />
          </Link>
          <div className="navlink-container">
            <NavLink to="/" end onClick={scrollToTop}>
              Home
            </NavLink>
            <NavLink to="/about" onClick={scrollToTop}>
              About
            </NavLink>
            <NavLink to="/subjects" onClick={scrollToTop}>
              Subjects
            </NavLink>
            <NavLink to="/courses" onClick={scrollToTop}>
              Courses
            </NavLink>
            <NavLink to="/contact" onClick={scrollToTop}>
              Contact
            </NavLink>
          </div>
          <Link className="btn" to="/assessment" onClick={scrollToTop}>
            Book a free assessment
          </Link>
        </div>

        <div
          className={`mobile-header ${
            scrolled ? "scrolled" : ""
          } ${headerThemeClass}`}
        >
          <div className="mobile-topbar">
            <Link to="/" className="mobile-logo">
              <img
                src="https://d1sq738v7irhr2.cloudfront.net/design-system/citos-logo.webp"
                alt="Citos logo"
              />
            </Link>

            <Icon
              className="icon"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
              icon="material-symbols:menu-rounded"
            />
          </div>
          {menuOpen && (
            <div
              className="mobile-overlay"
              onClick={() => setMenuOpen(false)}
            />
          )}
          <div
            className={`mobile-menu ${
              menuOpen ? "open" : ""
            } ${menuThemeClass}`}
          >
            <Link to="/" className="header-logo" onClick={scrollToTop}>
              <img
                src="https://d1sq738v7irhr2.cloudfront.net/design-system/citos-logo.webp"
                alt="citos logo"
              />
            </Link>

            <Icon
              className="icon"
              onClick={() => setMenuOpen(false)}
              aria-label="Toggle menu"
              icon="mingcute:close-line"
            />

            <NavLink
              to="/"
              end
              onClick={() => {
                setMenuOpen(false);
                scrollToTop();
              }}
              className="mobile-navlink"
            >
              Home
            </NavLink>
            {menuThemeClass && <hr />}
            <NavLink
              to="/about"
              onClick={() => {
                setMenuOpen(false);
                scrollToTop();
              }}
              className="mobile-navlink"
            >
              About
            </NavLink>
            {menuThemeClass && <hr />}
            <NavLink
              to="/subjects"
              onClick={() => {
                setMenuOpen(false);
                scrollToTop();
              }}
              className="mobile-navlink"
            >
              Subjects
            </NavLink>
            {menuThemeClass && <hr />}
            <NavLink
              to="/courses"
              onClick={() => {
                setMenuOpen(false);
                scrollToTop();
              }}
              className="mobile-navlink"
            >
              Courses
            </NavLink>
            {menuThemeClass && <hr />}
            <NavLink
              to="/contact"
              onClick={() => {
                setMenuOpen(false);
                scrollToTop();
              }}
              className="mobile-navlink"
            >
              Contact
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
